import FileImageIcon from '@/public/icons/record/file.svg';
import DoxcIcon from '@/public/icons/record/docx.svg';
import PptIcon from '@/public/icons/record/ppt.svg';
import XlsxIcon from '@/public/icons/record/xlsx.svg';
import ZipIcon from '@/public/icons/record/zip.svg';
import HwpIcon from '@/public/icons/record/hwp.svg';
import TxtIcon from '@/public/icons/record/txt.svg';
import PdfIcon from '@/public/icons/record/pdf.svg';
import AudioIcon from '@/public/icons/record/audio.svg';

export const getFileType = (filename: string) => {
  const ext = filename.split('.').pop()?.toLowerCase();

  if (!ext) return 'unknown';

  switch (ext) {
    case 'doc':
    case 'docx':
      return 'doc';
    case 'ppt':
    case 'pptx':
      return 'ppt';
    case 'xls':
    case 'xlsx':
      return 'xls';
    case 'zip':
    case '7z':
    case 'rar':
      return 'zip';
    case 'hwp':
      return 'hwp';
    case 'txt':
      return 'txt';
    case 'pdf':
      return 'pdf';
    case 'mp3':
    case 'wav':
    case 'm4a':
    case 'aac':
    case 'webm':
      return 'audio';
    case 'mp4':
    case 'mov':
    case 'avi':
      return 'video';
    default:
      return 'unknown';
  }
};

type P = {
  fileName: string;
};

const FileIcon = ({ fileName }: P) => {
  const type = getFileType(fileName);

  const renderIcon = () => {
    switch (type) {
      case 'doc':
        return <DoxcIcon width={10.9} height={12.3} />;
      case 'ppt':
        return <PptIcon width={10.9} height={12.3} />;
      case 'xls':
        return <XlsxIcon width={10.9} height={12.3} />;
      case 'zip':
        return <ZipIcon width={10.9} height={12.3} />;
      case 'hwp':
        return <HwpIcon width={10.9} height={12.3} />;
      case 'txt':
        return <TxtIcon width={10.9} height={12.3} />;
      case 'pdf':
        return <PdfIcon width={10.9} height={12.3} />;
      case 'audio':
        return <AudioIcon width={14} height={14} />;
      default:
        return <FileImageIcon width={10.9} height={12.3} />;
    }
  };

  return (
    <div
      style={{
        width: '16px',
        height: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        objectFit: 'cover',
      }}
    >
      {renderIcon()}
    </div>
  );
};
export default FileIcon;
